import { LoadingContext } from "../Context";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { BaseRouteParams, PostType } from "../Structures";
import {
  TransactionGetPost,
  TransactionPostBlogComment,
} from "../Services/Transactions";
import { formatDate, rating, Toast } from "../Utils";
import { Button, Tag } from "../Components/Base";
import { Link } from "react-router-dom";
import { useScrollTop } from "../Hooks";

const Post = () => {
  const params = useParams<BaseRouteParams>();
  const navigate = useNavigate();

  const { setLoading } = useContext(LoadingContext);

  // ===========================================================

  const [commentMessage, setCommentMessage] = useState<string>("");
  const [isCommentLoading, setIsCommentLoading] = useState<boolean>(false);
  const [post, setPost] = useState<PostType>({
    categories: [],
    comments: [],
    contents: [],
    description: "",
    poster: "",
    related_posts: [],
    thumbnail: "",
    timeStamp: "",
    title: "",
  });

  // ===========================================================

  const handleSubmitForm = (e: Event) => {
    e.preventDefault();
    if (commentMessage) {
      setIsCommentLoading(true);
      TransactionPostBlogComment({
        article_id: Number(params.id),
        message: commentMessage,
        star: 5,
      })
        .then(({ data: res }) => {
          if (res.transaction_status) {
            setCommentMessage("");
          }
          Toast(res.transaction_status ? "success" : "error", res.message);
        })
        .finally(() => setIsCommentLoading(false));
    }
  };

  // ===========================================================

  useEffect(() => {
    if (params.id) {
      setLoading(true);
      document.getElementById("root")!.scrollTo(0, 0);
      TransactionGetPost(params.id)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            setPost(res.data!);
          } else {
            navigate("/blog");
            Toast("error", "پست مورد نظر یافت نشد.");
          }
        })
        .finally(() => setLoading(false));
    } else navigate("/blog");
  }, [params.id]);

  // ===========================================================

  return (
    <Fragment>
      <section
        className="bg-dark-overlay-5"
        style={{
          backgroundImage: `url(${post.thumbnail})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8 py-md-5 my-lg-5">
              {post.categories.map((tag) => (
                <Tag tag={tag} key={tag.id} />
              ))}
              <h1 className="text-white">{post.title}</h1>
              <p className="lead text-white text-justify">{post.description}</p>

              <ul className="nav nav-divider text-white-force align-items-center">
                <li className="nav-item">{formatDate(post.timeStamp)}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container position-relative" data-sticky-container>
          <div className="row">
            <div className="col-lg-9 mb-5">
              {post.contents.map((content) => (
                <div
                  className="mb-4 d-flex justify-content-center align-content-center flex-column gap-2"
                  key={content.id}
                >
                  {content.image ? (
                    <div className="card mb-3" style={{ width: "100%" }}>
                      <img
                        className="w-100 h-100 object-fit-contain rounded-3 bg-dark-overlay-6"
                        src={content.image}
                      />
                    </div>
                  ) : null}
                  <div className="d-flex justify-content-center align-content-center gap-2 flex-column">
                    <h3>{content.title}</h3>
                    <p className="text-justify">{content.description}</p>
                  </div>
                </div>
              ))}

              <hr />

              {post.comments.length ? (
                <div>
                  <h3>{post.comments.length} دیدگاه</h3>

                  {post.comments.map((comment) => (
                    <div key={comment.id} className="my-4 d-flex">
                      <img
                        className="avatar avatar-md rounded-circle float-start me-3"
                        src={comment.owner.profile}
                        alt={`${comment.owner.full_name} کامنت`}
                      />
                      <div>
                        <div className="mb-2">
                          <div className="d-flex justify-content-start align-items-center gap-3">
                            <h5 className="m-0">{comment.owner.full_name}</h5>
                            <span>-</span>
                            <span dir="ltr" className="text-info fs-5">
                              {rating(comment.star)}
                            </span>
                          </div>
                          <span className="me-3 small">
                            {formatDate(comment.timeStamp)} -{" "}
                            <span dir="ltr">{comment.owner.phoneNumber}</span>
                          </span>
                        </div>
                        <p className="text-justify">{comment.message}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}

              <div>
                <h3>ثبت دیدگاه</h3>
                <form className="row g-3 mt-2">
                  <div className="col-12">
                    <label className="form-label">متن دیدگاه</label>
                    <textarea
                      value={commentMessage}
                      onChange={(e) => setCommentMessage(e.target.value)}
                      className="form-control resize-none"
                      rows={5}
                    />
                  </div>
                  <div className="col-12 ">
                    <Button
                      text="ثبت"
                      btnClass="btn-primary w-25"
                      isLoading={isCommentLoading}
                      disabled={!!!commentMessage.length}
                      onClick={handleSubmitForm}
                    />
                  </div>
                </form>
              </div>
            </div>

            <div className="col-lg-3">
              <div data-sticky data-margin-top="80" data-sticky-for="991">
                <div>
                  <h3 className="mb-3">اخبار مشابه</h3>
                  <div className="mt-3 mb-5">
                    {post.related_posts.map((relatedPost, index) => (
                      <Link
                        key={relatedPost.id}
                        to={`/blog/${relatedPost.id}`}
                        className={`card pb-3 ${
                          index != 0 ? "border-top" : ""
                        } border-black border-opacity-25 rounded-0`}
                      >
                        <div className=" card-body p-0 pt-3">
                          <h5 className="card-title truncate">
                            <span className="btn-link text-reset">
                              {relatedPost.title}
                            </span>
                          </h5>
                        </div>
                        <div
                          className="position-relative"
                          style={{ height: 70 }}
                        >
                          <img
                            className="card-img w-100 h-100 object-fit-cover"
                            src={relatedPost.poster}
                            alt="Card image"
                          />
                          <div className="card-img-overlay d-flex align-items-start flex-column p-2">
                            <div className="w-100">
                              {relatedPost.categories.map((tag) => (
                                <Tag tag={tag} key={tag.id} />
                              ))}
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Post;
